import { darkTheme } from '../../theme/tokens';
import type { Chip } from './buildSuggestions';

const t = darkTheme;

export interface SuggestionChipsProps {
  chips: readonly Chip[];
  onPick: (prompt: string) => void;
  disabled?: boolean;
}

export function SuggestionChips({ chips, onPick, disabled = false }: SuggestionChipsProps) {
  if (chips.length === 0) return null;
  return (
    <div
      data-testid="suggestion-chips"
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 8,
        marginTop: 20,
        marginBottom: 16,
      }}
    >
      {chips.map((chip, i) => (
        <button
          key={`${chip.label}-${i}`}
          type="button"
          onClick={() => onPick(chip.prompt)}
          disabled={disabled}
          data-testid="suggestion-chip"
          style={{
            background: t.surface,
            border: `1px solid ${t.border}`,
            borderRadius: 999,
            padding: '8px 14px',
            color: disabled ? t.text3 : t.text2,
            fontSize: 13,
            fontFamily: 'inherit',
            cursor: disabled ? 'not-allowed' : 'pointer',
            transition: 'background 0.15s, border-color 0.15s, color 0.15s',
            opacity: disabled ? 0.6 : 1,
          }}
        >
          {chip.label}
        </button>
      ))}
    </div>
  );
}
